import { useQuery, UseQueryResult } from 'react-query';
import api from '../../utils/api/api';
import { API_PUBLIC_EVENTS } from '../../utils/api/constants';
import { Event } from '../../types/Events';

export const usePublicEventBySlug = (slug: string): UseQueryResult<Event, unknown> => {
  return useQuery(['publicEvent', slug], async () => {
    const { data } = await api.get(`${API_PUBLIC_EVENTS}/${slug}`);
    return data;
  });
};
